// SettingsDialog.js
import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogActions, DialogContent, DialogTitle,
    TextField, Button, FormControl, InputLabel, Select, MenuItem, Box
} from '@mui/material';

export default function SettingsDialog({
                                           open, onClose, onSave,
                                           initialName, initialDescription,
                                           initialProvider = 'openai',
                                           initialModel = 'gpt-5.4',
                                           t
                                       }) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    const [provider, setProvider] = useState(initialProvider);
    const [model, setModel] = useState(initialModel);

    useEffect(() => {
        setName(initialName || '');
        setDescription(initialDescription || '');
        setProvider(initialProvider || 'openai');
        setModel(initialModel || 'gpt-5.4');
    }, [initialName, initialDescription, initialProvider, initialModel, open]);

    // Models mirror DevSettingsPanel.js
    const renderModelOptions = () => {
        if (provider === 'openai') {
            return [
                'gpt-5.5', 'gpt-5.4', 'gpt-5.4-mini',
                'gpt-5.5-pro', 'gpt-5.4-pro', 'gpt-5.4-nano',
                'gpt-oss-120b', 'gpt-oss-20b'
            ].map(m => <MenuItem key={m} value={m}>{m}</MenuItem>);
        }
        if (provider === 'gemini') {
            return ([
                ['gemini-3.5-flash', 'Gemini 3.5 Flash'],
                ['gemini-3.1-flash-lite', 'Gemini 3.1 Flash Lite'],
                ['gemini-3.1-pro-preview', 'Gemini 3.1 Pro Preview'],
                ['gemini-3-flash-preview', 'Gemini 3 Flash Preview'],
                ['gemini-2.5-flash', 'Gemini 2.5 Flash'],
                ['gemini-2.5-flash-lite', 'Gemini 2.5 Flash Lite'],
                ['gemini-2.5-pro', 'Gemini 2.5 Pro'],
            ]).map(([val, label]) => <MenuItem key={val} value={val}>{label}</MenuItem>);
        }
        // local
        return ([
            ['mistral', 'mistral'],
            ['llama3', 'llama3'],
            ['gemma', 'gemma'],
            ['phi:2.7b', 'phi:2.7b'],
            ['gemma3', 'gemma3'],
        ]).map(([val, label]) => <MenuItem key={val} value={val}>{label}</MenuItem>);
    };

    const handleSave = () => {
        onSave({
            name,
            description,
            // Send canonical keys the backend expects:
            llm_provider: provider,
            llm_model: model,
        });
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t("edit_settings_title")}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label={t("name")}
                    fullWidth
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <TextField
                    margin="dense"
                    label={t("description")}
                    fullWidth
                    multiline
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />

                {/* Provider / Model */}
                {/*<Box mt={2} />*/}
                {/*<FormControl fullWidth margin="dense" size="small">*/}
                {/*    <InputLabel id="provider-label">{t("provider")}</InputLabel>*/}
                {/*    <Select*/}
                {/*        labelId="provider-label"*/}
                {/*        id="provider-select"*/}
                {/*        label={t("provider")}*/}
                {/*        value={provider}*/}
                {/*        onChange={(e) => {*/}
                {/*            const next = e.target.value;*/}
                {/*            setProvider(next);*/}
                {/*            // simple: keep model if still valid; otherwise pick the first option*/}
                {/*            setModel(prev => {*/}
                {/*                if (next === 'openai' && !['gpt-4.1','gpt-4o','o4-mini','o3-mini','o1','gpt-4.1-mini','gpt-4.1-nano','gpt-4o-mini'].includes(prev)) return 'gpt-4.1';*/}
                {/*                if (next === 'gemini' && !['gemini-2.5-flash-preview-04-17','gemini-2.5-pro-preview-05-06','gemini-2.0-flash','gemini-2.0-flash-lite','gemini-1.5-flash','gemini-1.5-flash-8b','gemini-1.5-pro'].includes(prev)) return 'gemini-2.0-flash';*/}
                {/*                if (next === 'local' && !['mistral','llama3','gemma','phi:2.7b','gemma3'].includes(prev)) return 'llama3';*/}
                {/*                return prev;*/}
                {/*            });*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        <MenuItem value="openai">OpenAI</MenuItem>*/}
                {/*        <MenuItem value="gemini">Gemini</MenuItem>*/}
                {/*        <MenuItem value="local">local</MenuItem>*/}
                {/*    </Select>*/}
                {/*</FormControl>*/}

                {/*<FormControl fullWidth margin="dense" size="small">*/}
                {/*    <InputLabel id="model-label">{t("model")}</InputLabel>*/}
                {/*    <Select*/}
                {/*        labelId="model-label"*/}
                {/*        id="model-select"*/}
                {/*        label={t("model")}*/}
                {/*        value={model}*/}
                {/*        onChange={(e) => setModel(e.target.value)}*/}
                {/*    >*/}
                {/*        {renderModelOptions()}*/}
                {/*    </Select>*/}
                {/*</FormControl>*/}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t("cancel")}</Button>
                <Button onClick={handleSave}>{t("save")}</Button>
            </DialogActions>
        </Dialog>
    );
}
